import { formatDate } from '@airship-platform/airship-patterns';
import {
  FlexBox,
  SanitizedTrimmedHtml,
} from '@airship-platform/jam-web/components';
import {
  ChevronLeftIcon,
  ChevronRightIcon,
} from '@airship-platform/jam-web/icons';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Typography from '@mui/material/Typography';
import { ServiceHistory } from '../../../../data-access/serviceHistory';

type MobileServiceHistoryViewProps = {
  paginatedServiceHistory: ServiceHistory[];
  page: number;
  rowsPerPage: number;
  handleChangePage: (newPage: number) => void;
  totalServiceHistory: number;
};

const MobileServiceHistoryView: React.FC<MobileServiceHistoryViewProps> = ({
  paginatedServiceHistory,
  page,
  rowsPerPage,
  handleChangePage,
  totalServiceHistory,
}) => (
  <>
    <List>
      {!paginatedServiceHistory.length ? (
        <Typography align="center">No service history found</Typography>
      ) : (
        paginatedServiceHistory.map((item) => (
          <ListItem key={item.jobId} divider>
            <FlexBox flexDirection={'column'} gap={1} py={2}>
              <Typography variant="subtitle2">
                {formatDate(item.lastAppointmentDate)}
              </Typography>
              <Typography component={'div'} variant="body2">
                <SanitizedTrimmedHtml
                  html={item.jobSummary}
                  variant="body3"
                  maxLength={250}
                />
              </Typography>
              <Typography variant="body2">
                Technician: {item.assignedUserFirstName}
              </Typography>
              <Typography variant="body2">Status: {item.status}</Typography>
            </FlexBox>
          </ListItem>
        ))
      )}
    </List>
    {paginatedServiceHistory.length !== 0 && (
      <FlexBox justifyContent="space-between" alignItems="center" mt={2}>
        <IconButton
          onClick={() => handleChangePage(page - 1)}
          disabled={page === 0}
          size="small"
        >
          <ChevronLeftIcon />
        </IconButton>
        <Typography variant="caption">
          Page {page + 1} of {Math.ceil(totalServiceHistory / rowsPerPage)}
        </Typography>
        <IconButton
          onClick={() => handleChangePage(page + 1)}
          disabled={page >= Math.ceil(totalServiceHistory / rowsPerPage) - 1}
          size="small"
        >
          <ChevronRightIcon />
        </IconButton>
      </FlexBox>
    )}
  </>
);

export default MobileServiceHistoryView;
